<template>
  <!-- 内容区 -->
  <div class="portfolio">
    <!-- banner -->
    <div class="banner-home banner-small">
      <div class="container">
        <img src="../assets/images/title-works.svg" class="banner-title" />
      </div>
    </div>
    <div class="container">
      <div class="wrap">
        <!-- Tab panes -->
        <div class="tabs-wrap">
          <ul class="nav nav-tabs" role="tablist">
            <li
              role="presentation"
              v-for="(category, index) in categoryList"
              :key="category.category_id"
              @click="changeCategory(category.category_id)"
            >
              <a
                href="#award-1"
                :class="{ active: curCategory == category.category_id }"
                role="tab"
                data-toggle="tab"
                ><img
                  :src="require(`../assets/images/icon-class-${index + 1}.svg`)"
                  class="icon-class"
                />{{ category.name }}</a
              >
            </li>
          </ul>
        </div>
        <div class="tab-content">
          <div role="tabpanel" class="tab-pane active" id="award-1">
            <div class="list">
              <div
                class="card-box"
                v-for="vote in voteList"
                :key="vote.vote_id"
              >
                <router-link
                  :to="{ name: 'WorksDetail', params: { id: vote.vote_id } }"
                  class="card"
                >
                  <img class="card-cover" :src="vote.image" />
                  <div class="card-body">
                    <h5 class="card-title">
                      {{ vote.vote_code }} {{ vote.title }}
                    </h5>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <nav v-if="totalPage > 0">
          <ul class="pagination  pagination-lg justify-content-center">
            <li class="page-item" :class="[curPage == 1 ? 'disabled' : '']">
              <a
                class="page-link"
                @click="reducePage"
                tabindex="-1"
                aria-disabled="true"
                ><i class="iconfont icon-arrow-left"></i
              ></a>
            </li>
            <li
              class="page-item"
              :class="[page == curPage ? 'active' : '']"
              v-for="page in totalPage"
              :key="page"
            >
              <a class="page-link" @click="changePage(page)">{{ page }}</a>
            </li>
            <li
              class="page-item"
              :class="[curPage == totalPage ? 'disabled' : '']"
            >
              <a class="page-link" @click="addPage" aria-disabled="true"
                ><i class="iconfont icon-arrow-right"></i
              ></a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { voteCategory, voteList } from "@/network/API.js";
export default {
  data() {
    return {
      categoryList: [],
      voteList: [],
      curCategory: "",
      curPage: 1,
      totalPage: 0
    };
  },
  created() {
    this.getCategory();
  },
  methods: {
    async getCategory() {
      this.categoryList = await voteCategory();
      this.curCategory = this.categoryList[0].category_id;
      this.getVoteList();
    },
    async getVoteList() {
      let res = await voteList({
        category_id: this.curCategory,
        subject_id: "1",
        page: this.curPage,
        page_size: 12,
        keyword: ""
      });
      let tPage = parseInt(res.total);
      this.totalPage = tPage % 10 == 0 ? tPage / 12 : parseInt(tPage / 12) + 1;
      this.voteList = res.list;
      console.log(this.voteList);
    },
    changeCategory(cid) {
      this.curCategory = cid;
      this.curPage = 1
      this.getVoteList();
    },
    reducePage(){
        this.curPage -= 1
        this.getVoteList()
    },
    addPage(){
        this.curPage += 1
        this.getVoteList()
    },
    changePage(page){
        console.log('current page is ',page);
        this.curPage = page
        this.getVoteList()
    }
  }
};
</script>

<style>
.card-cover {
  width: 340px;
  height: 220px;
}
</style>



// WEBPACK FOOTER //
// src/views/worksList.vue